<!-- 使用 list-type 属性来设置文件列表的样式 -->
<template>
	<div class="file-upload">
		<el-upload
			list-type="picture-card"
			:data="additionalData"
			:headers="headers"
			:action="uploadFileUrl"
			:before-upload="handleBeforeUpload"
			:on-success="handleUploadSuccess"
			:on-error="handleUploadError"
			:auto-upload="true"
			:file-list="fileList">
			<el-icon class="avatar-uploader-icon"><plus /></el-icon>
			<template #file>
				<div class="fileClass">
					<i class="el-icon-document">
						<el-tooltip class="btn-trip" effect="dark" placement="bottom">
							<span>
								<p>name</p>
							</span>
						</el-tooltip>
					</i>
					<i class="el-icon-download">
						<el-tooltip class="btn-trip" effect="dark" placement="bottom">
							<span>
								<p>下载文件</p>
							</span>
						</el-tooltip>
					</i>
				</div>
			</template>
		</el-upload>
		<p style="color: #bbb; font-size: 10px" v-if="props.isShowTip">文件后缀名可为{{ fileType.join('/') }}等，文件大小不得大于{{ fileSize }}M。</p>
	</div>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { listToString, useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	modelValue: [String, Object, Array],
	// 数量限制
	limit: {
		type: Number,
		default: 5
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 1024
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['mp3', 'mp4', 'wma', 'rmvb', 'rm']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})

const { proxy } = getCurrentInstance()

const uploadFileUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

const fileList = ref([]) //显示的列表
const modeList = ref([]) //正确的列表

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}
//上传成功, 数据双向绑定
function handleUploadSuccess(file, files) {
	modeList.value = []
	if (res && res.ResData) {
		//当前上传的临时URL
		let curUrl = files.url
		//当前上传正确的图片信息
		let cname = res.ResData.FileName
		let cicon = res.ResData.FilePath
		//把临时的指替换成正确的指
		fileList.value.forEach((item, index) => {
			let name = item.name
			let url = item.url
			if (item.url == curUrl) {
				name = cname
				url = cicon
			}
			modeList.value.push({ name: name, url: url })
		})
		//更新正确的值用于提交到后端
		emit('update:modelValue', listToString(modeList.value))
	} else {
		ElMessage.error(res.ErrMsg)
	}
}

// 上传失败
function handleUploadError() {
	proxy.$modal.msgError('上传失败')
}

// 预览
function handlePreview(file) {
	window.console.log(file)
}

// 删除图片
function handleRemove(file, files) {
	const findex = files.value.map((f) => f.name).indexOf(file.name)
	if (findex > -1) {
		modeList.value.splice(findex, 1)
		emit('update:modelValue', listToString(modeList.value))
	}
}
// 下载已上传附件
function projectDownload(file) {
	if (!file.url) {
		return
	}
	window.open(`file/download?filePath=${file.url}&openStyle=1`)
}

// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			// 首先将值转为数组
			let list = Array.isArray(val) ? val : val.split(',')
			// 然后将数组转为对象数组
			fileList.value = list.map((item) => {
				if (typeof item === 'string') {
					//显示时加路径
					return { name: item, url: useImageUrl(item) }
				}
			})
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.file-upload {
}

.fileClass {
	width: 90px;
	height: 70px;
	text-align: center;
	background: rgba(67, 137, 249, 0.16);
	border-radius: 5px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	margin: 5px;

	.el-icon-download {
		display: none;
	}
	&:hover {
		.el-icon-document {
			display: none;
		}
		.el-icon-download {
			display: block;
		}
	}
	p,
	.btn-trip {
		display: block;
		font-size: 12px;
		font-weight: 500;
		color: #4389f9;
		max-width: calc(100px);
		padding: 0 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	i {
		font-size: 30px;
		font-weight: bold;
		color: #00cfff;
	}
	.deleteIcon {
		font-size: 16px;
		font-weight: 100;
		color: #f1615d;
		background: rgba($color: #fff, $alpha: 1);
		border-radius: 50%;
		position: absolute;
		z-index: 1800;
		pointer-events: auto;
		top: -5px;
		right: -5px;

		&:hover {
			color: #fff;
			background: #4389f9;
		}
	}
}
</style>
